<template>
    <main role="main" class="container text-center p-5">
        <div style="padding-bottom: 250px;">
            <h1>404: Страница не найдена</h1>
            <a href="/">Вернуться на главную</a>
        </div>
    </main>
</template>

<script>
    export default {
        name: "PageNotFound",
        metaInfo: {
            title: 'Страница не найдена',
            titleTemplate: '%s - sale.katris'
        },
    }
</script>

<style scoped>

</style>